import { render, staticRenderFns } from "./AddReviewDialog.vue?vue&type=template&id=527abf08&scoped=true&"
import script from "./AddReviewDialog.vue?vue&type=script&lang=js&"
export * from "./AddReviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527abf08",
  null
  
)

export default component.exports